'use strict';

class EventUtils
{
    static getAttributeValue(evt: any, attribute: any){
        return evt.currentTarget.attributes.getNamedItem(attribute).value;
    }
}

export default EventUtils;